/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles/';
import { useSelector } from 'react-redux';
import translate from '@noar-basf/commons';
import {
  Portlet,
  PortletBody
} from "../content/Portlet";
import {
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableRow,
  TableFooter,
  TableHead,
  TableSortLabel,
  Paper
} from '@material-ui/core';

const EnhancedTableHead = (props) => {
  const { order, orderBy, onRequestSort, headRows } = props;

  const createSortHandler = property => event => {
    if (!property) {
      return;
    }

    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {(headRows || []).map((row, i) => (
          <TableCell
            key={row.column || i}
            align={row.align ? row.align : 'left'}
            padding={row.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === row.column ? order : false}
            size={row.size || null}
            width={row.width || undefined}
          >
            {row.column
              ? (
                <TableSortLabel
                  active={orderBy === row.column}
                  direction={order}
                  onClick={createSortHandler(row.column)}
                >
                  {row.label}
                </TableSortLabel>
              ) : (
                row.label
              )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  headRows: PropTypes.array.isRequired
};

function DatatableStandalone(props) {
  const locale = useSelector(({ i18n }) => i18n.lang);
  const { widthTable } = props;
  const useStyles = makeStyles(theme => {
    return ({
      root: {
        width: '100%',
        marginTop: theme.spacing(0),
      },
      paper: {
        width: '100%',
        marginBottom: theme.spacing(0),
      },
      table: {
        minWidth: widthTable ? widthTable : 400,
      },
      tableWrapper: {
        overflowX: 'auto',
      },
      search: {
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
      },
      radio: {
        flexWrap: 'nowrap',
        padding: '1rem',
      }
    })
  });

  const classes = useStyles();
  const currentState = loadPaginationState();

  const rows = props.rows;
  const [order, setOrder] = React.useState(currentState.order || 'desc');
  const [orderBy, setOrderBy] = React.useState(
    currentState.orderBy
    || props.orderBy
    || props.headRows[0].column
    || 'Id'
  );
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(currentState.perPage || 10);

  function loadPaginationState() {
    const paginationState = JSON.parse(localStorage.getItem('pagination') || '{}');
    if (paginationState[props.endpoint]) {
      return paginationState[props.endpoint];
    }

    return {};
  }

  function handleRequestSort(event, property) {
    const isDesc = orderBy === property && order === 'desc';
    const direction = isDesc ? 'asc' : 'desc';
    setOrder(direction);
    setOrderBy(property);
  }

  function handleChangePage(event, newPage) {
    setPage(newPage);
  }

  function handleChangeRowsPerPage(event) {
    setPage(0);
    setRowsPerPage(+event.target.value);
  }

  return (
    <div className={`col-xl-12 ${props.className}`} style={{ marginTop: "10px" }}>
      <Portlet fluidHeight={true}>
        <PortletBody fit={true}>
          <div className={classes.root}>
            <Paper className={classes.paper}>
              <div className={classes.tableWrapper}>
                <Table className={classes.table}>
                  <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    rowCount={rows.length}
                    headRows={props.headRows}
                  />
                  <TableBody>
                    {(
                      rows.length > 0 ?
                        rows.map((row) => props.formatRow(row)) :
                        <TableRow>
                          <TableCell colSpan={props.headRows.length} className='text-center'>
                            {translate(locale).datatable.nothingData}
                          </TableCell>
                        </TableRow>
                    )}
                  </TableBody>
                </Table>
                <Table>
                  <TableFooter>
                    <TableRow>
                      <TablePagination
                        rowsPerPageOptions={[10, 20, 50]}
                        labelDisplayedRows={({ from, to, count }) => `${from}-${to} ${translate(locale).datatable.of} ${count}`}
                        colSpan={10}
                        count={rows.length || 0}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        labelRowsPerPage={translate(locale).datatable.labelRowsPerPage}
                        backIconButtonProps={{
                          'aria-label': translate(locale).datatable.backButton,
                        }}
                        nextIconButtonProps={{
                          'aria-label': translate(locale).datatable.nextButton,
                        }}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                      />
                    </TableRow>
                  </TableFooter>
                </Table>
              </div>
            </Paper>
          </div>
        </PortletBody>
      </Portlet>
    </div>
  );
}

export default DatatableStandalone;
